import { render, staticRenderFns } from "./PolicyLimit.vue?vue&type=template&id=0efbf5d8&scoped=true"
import script from "./PolicyLimit.vue?vue&type=script&lang=js"
export * from "./PolicyLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbf5d8",
  null
  
)

export default component.exports